import React from 'react';
import MetaData from '@minecraft.meta-data';
import { useTranslation } from '@blocs.i18n';

const Meta = () => {
  const { t } = useTranslation();
  return <MetaData title={t('login:login.meta.title')} description={t('login:login.meta.description')} />;
};

export default Meta;
